import React from 'react'
import DOMPurify from 'dompurify'

interface SanitizedHtmlProps {
  html: string
  className?: string
}

/**
 * Renders HTML content sanitized with DOMPurify. Use this instead of
 * dangerouslySetInnerHTML whenever HTML content needs to be rendered.
 */
export const SanitizedHtml: React.FC<SanitizedHtmlProps> = ({
  html,
  className,
}) => (
  <div
    className={className}
    // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(html, { USE_PROFILES: { html: true } }),
    }}
  />
)
